import React from "react";
import { useLocation } from "react-router-dom";
import { Home } from './Home';

function HomeWrapEncrypted() {
    const [isDataLoaded, setIsDataLoaded] = React.useState(false);
    const [discussionIdentifier, setDiscussionIdentifier] = React.useState("");
    const [clientIdentifier, setClientIdentifier] = React.useState("");
    const [userIdentifier, setUserIdentifier] = React.useState("");
    const [userType, setUserType] = React.useState("");

    let location = useLocation(); 
    let encryptedString = location.pathname.slice(1);
    let encryptedAndIV = encryptedString.split('/');

    const request = async () => {
        const response = await fetch("/api/cipher/decrypt/" + encryptedAndIV[0] + "/" + encryptedAndIV[1]);
        const text = await response.text();
        var dataArray = text.split('/');
        var reg = new RegExp('^[0-9]{3}$');

        if (reg.test(dataArray[1])) {
            setDiscussionIdentifier(dataArray[0]);
            setClientIdentifier(dataArray[1])
            setUserIdentifier(dataArray[2]);
            setUserType(dataArray[3]);
            setIsDataLoaded(true);
        }
        else {
            setDiscussionIdentifier(dataArray[0]);
            setClientIdentifier("000")
            setUserIdentifier(dataArray[1]);
            setUserType(dataArray[2]);
            setIsDataLoaded(true);
        }     
    }
    request();

    if (isDataLoaded === true) {
        return (
            <Home discussionIdentifier={discussionIdentifier}
                  clientIdentifier={clientIdentifier}
                  userIdentifier={userIdentifier}
                  userType={userType}
            />
        );
    }
}
export default HomeWrapEncrypted;